/**
 * 選択済みの食品（カート）。行ごとに倍率を打ち込んで変えたり、外したりできる
 */

import { ShoppingCart, X } from 'lucide-react'

import type { UnifiedCartItem } from './cart-utils'
import { MultiplierInput } from './multiplier-input'

type Props = {
  items: UnifiedCartItem[]
  onMultiplierChange: (item: UnifiedCartItem, multiplier: number) => void
  onRemove: (item: UnifiedCartItem) => void
}

export function UnifiedCart({ items, onMultiplierChange, onRemove }: Props) {
  if (items.length === 0) return null

  const sum = (pick: (i: UnifiedCartItem) => number) => items.reduce((s, i) => s + pick(i), 0)

  return (
    <div className="space-y-1 rounded-md border border-border p-2">
      <div className="mb-1 flex items-center gap-1 text-[10px] font-medium text-muted-foreground">
        <ShoppingCart className="size-3" />
        選択済み ({items.length})
      </div>
      {items.map((item, idx) => (
        <div key={`${item.key}-${item.food_name}-${idx}`} className="flex items-center gap-1.5 text-xs">
          <button
            type="button"
            className="p-0 text-muted-foreground transition-colors hover:text-destructive"
            onClick={() => onRemove(item)}
            aria-label="外す"
          >
            <X className="size-3" />
          </button>
          <span className="min-w-0 flex-1 truncate">
            {item.food_name}
            {item.source === 'template' && item.templateName && (
              <span className="ml-1 text-[10px] text-amber-500">({item.templateName})</span>
            )}
          </span>
          <span className="flex shrink-0 items-center gap-0.5 text-muted-foreground">
            ×
            <MultiplierInput
              value={item.multiplier}
              onChange={(v) => onMultiplierChange(item, v)}
              aria-label={`${item.templateName ?? item.food_name} の倍率`}
            />
          </span>
          <span className="w-14 shrink-0 text-right tabular-nums text-muted-foreground">
            {Math.round(item.calories)}kcal
          </span>
        </div>
      ))}
      <div className="mt-1 flex justify-between border-t border-border pt-1 text-xs font-medium">
        <span>合計</span>
        <span className="tabular-nums">
          {Math.round(sum((i) => i.calories))}kcal | P{sum((i) => i.protein_g).toFixed(0)}g | F
          {sum((i) => i.fat_g).toFixed(0)}g | C{sum((i) => i.carb_g).toFixed(0)}g
        </span>
      </div>
    </div>
  )
}
